import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import photo_1 from '../assets/photo_1.jpg';
import photo_2 from '../assets/photo_2.jpg';
import photo_3 from '../assets/photo_3.jpg';
import photo_5 from '../assets/photo_5.jpg';
import photo_6 from '../assets/photo_6.jpg';
import photo_7 from '../assets/photo_7.jpg';
import photo_8 from '../assets/photo_8.jpg';
import photo_9 from '../assets/photo_9.jpg';
import photo_10 from '../assets/photo_10.jpg';
import Program_11 from '../assets/Program_11.jpg';

const images = [
  photo_1,
  photo_2,
  photo_3,
  photo_5,
  photo_6,
  photo_7,
  photo_8,
  photo_9,
  photo_10,
  Program_11
];

const Slideshow = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        position: 'relative',
        width: '60%',
        height: { xs: 250, sm: 350, md: 500, lg: 600 }, // Responsive height
        overflow: 'hidden',
        margin: 'auto',
        borderRadius: 2,
        boxShadow: 3,
        mb: 4,
        backgroundColor: 'white',
      }}
    >
      {images.map((src, i) => (
        <Box
          key={i}
          component="img"
          src={src}
          alt={`Slide ${i}`}
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover', // Fill the box, cropping if needed
            opacity: i === index ? 1 : 0,
            transition: 'opacity 1s ease-in-out',
            zIndex: i === index ? 1 : 0,
          }}
        />
      ))}
    </Box>
  );
};

export default Slideshow;
